import { render, staticRenderFns } from "./AddUserProfile.vue?vue&type=template&id=0211c1d6&scoped=true&"
import script from "./AddUserProfile.vue?vue&type=script&lang=js&"
export * from "./AddUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./AddUserProfile.vue?vue&type=style&index=0&id=0211c1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0211c1d6",
  null
  
)

export default component.exports